import InitKioskBusinessManager from './InitKioskBusinessManager'
export default InitKioskBusinessManager
